// Dependencies
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Stores
import BackdropStore from '@/stores/backdrop'
import CartStore from '@/stores/cart'
import LanguageStore from '@/stores/language'
import PosterStore from '@/stores/poster'
import PeytilStore from '@/stores/peytil'
import CheckoutStore from '@/stores/checkout'
import InstagramStore from '@/stores/instagram'
import TrackingStore from '@/stores/tracking'
import CookiesStore from '@/stores/cookies'
import StructuredDataStore from '@/stores/structured-data'
import ContactStore from '@/stores/contact'
import GiftCards from '@/stores/gift-cards'
import Products from '@/stores/products'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  plugins: [
    createPersistedState()
  ],
  modules: {
    BackdropStore,
    CartStore,
    LanguageStore,
    PosterStore,
    PeytilStore,
    CheckoutStore,
    InstagramStore,
    TrackingStore,
    CookiesStore,
    StructuredDataStore,
    ContactStore,
    GiftCards,
    Products
  }
})



// WEBPACK FOOTER //
// ./src/store.js